import { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router";
import mainStyle from "../../header.module.scss";
// import { useAuth } from "contexts/AuthContext";
import { cloneDeep } from "lodash";
// material-ui
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Menu from "@mui/material/Menu";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";

// project import
import IconButton from "components/@extended/IconButton";

// assets
import { ReactComponent as Account } from "assets/images/icons/btn_header_account.svg";
import { ReactComponent as AccountHover } from "assets/images/icons/btn_header_account_hover.svg";
import { ReactComponent as Folder } from "assets/images/icons/icn_table_cell_Folder.svg";
import { ReactComponent as FolderHover } from "assets/images/icons/icn_table_cell_Folder_hover.svg";
import { ReactComponent as Logout } from "assets/images/icons/icn_table_cell_Logout.svg";
import { ReactComponent as LogoutHover } from "assets/images/icons/icn_table_cell_Logout_hover.svg";

//context
import useDataSourceManager from "hooks/useDataSourceManager";
import { useUserContext } from "contexts/UserContext";
import { getServerURL, getAppApiURL } from "../../../../../utils/serverUrl";
const checkMockup = process.env.REACT_APP_IS_MOCKUP;
// const orgID = process.env.REACT_APP_ORGANIZATIONNAME;

const defaultUser = {
  uId: "id-001",
  name: "butter",
  displayName: "butter",
  email: "butter@mail.com",
  avatar: "",
};

// const items = [
//   { label: "User Profile", path: "/account/profile" },
//   { label: "Log out", path: "/login" },
// ];

export default function Profile({wsData}) {
  const theme = useTheme();
  const navigate = useNavigate();
  const anchorRef = useRef(null);
  const { dataMap, getData, decodeTokenData, sendRequest, sendBatch } =
    useDataSourceManager(wsData);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isFolderHover, setIsFolderHover] = useState(false);
  const [isLogoutHover, setIsLogoutHover] = useState(false);

  // const { token } = useAuth();
  // const [userToken, setUserToken] = useState(null);
  const [originUser, setOriginUser] = useState(null);

  const { userState } = useUserContext();
  const serverURL = getServerURL();
  const serverApiURL = getAppApiURL();

  const handleMenuToggle = () => setMenuOpen((prev) => !prev);
  const handleMenuClose = () => setMenuOpen(false);
  // const handleMenuClick = (path) => {
  //   setMenuOpen(false);
  //   navigate(path);
  // };

  // 顯示名稱縮寫
  const getInitials = (name) => {
    return name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  };

  useEffect(() => {
    if (checkMockup === "true") {
      setOriginUser(cloneDeep(defaultUser));
    } else {
      if (userState) {
        let initUser = cloneDeep(userState);
        let tmpUser = {
          uId: initUser.id,
          name: initUser.name,
          displayName: initUser.displayName,
          email: initUser.email,
          avatar: initUser.avatar,
        };
        setOriginUser(tmpUser);
      }
    }
  }, [userState]);

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <IconButton
        sx={{
          p: 0.25,
          bgcolor: menuOpen ? "#e8ebfc" : "transparent",
          borderRadius: "24px",
          "&:hover": {
            bgcolor: "transparent",
          },
          "&:focus-visible": {
            outline: `2px solid ${theme.palette.secondary.dark}`,
            outlineOffset: 2,
          },
        }}
        aria-label="open profile"
        ref={anchorRef}
        aria-controls={menuOpen ? "profile-menu" : undefined}
        aria-haspopup="true"
        onClick={handleMenuToggle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Stack
          direction="row"
          spacing={1.25}
          alignItems="center"
          sx={{ p: 0.5 }}
        >
          {menuOpen ? (
            <Box
              sx={{
                bgcolor: "#e8ebfc",
                borderRadius: "24px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <AccountHover />
            </Box>
          ) : isHovered ? (
            <AccountHover />
          ) : (
            <Account />
          )}
        </Stack>
      </IconButton>

      <Menu
        id="profile-menu"
        anchorEl={anchorRef.current}
        open={menuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            mt: 1.5,
            ml: 2.5,
            borderRadius: 3,
            boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.08)",
            bgcolor: "#ffffff",
            maxWidth: 300,
            height: 280,
            border: "1px solid #f0f0f0",
            position: "relative",
            overflow: "visible",
            "&::before": {
              content: '""',
              position: "absolute",
              top: "-12px",
              right: "30px",
              width: 0,
              height: 0,
              borderLeft: "8px solid transparent",
              borderRight: "8px solid transparent",
              borderBottom: "12px solid #ffffff",
              filter:
                "drop-shadow(-2px -1px 2px rgba(0, 0, 0, 0.05)) drop-shadow(2px -1px 2px rgba(0, 0, 0, 0.05))",
              zIndex: 1,
            },
          },
        }}
      >
        <Box
          sx={{ display: "flex", justifyContent: "center", paddingTop: "10px" }}
        >
          {originUser ? (
            <div>
              {originUser.avatar ? (
                <img
                  src={originUser.avatar}
                  alt={`User ${originUser.displayName}`}
                  className={mainStyle["avatar-with-photo"]}
                />
              ) : (
                <div className={mainStyle["avatar-without-photo"]}>
                  {originUser && getInitials(originUser.displayName)}
                </div>
              )}
            </div>
          ) : (
            <div>No data available</div>
          )}
        </Box>

        {/* Username and Email */}
        {originUser && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              paddingTop: "10px",
            }}
          >
            <Typography sx={{ fontSize: "15px", fontWeight: "bold" }}>
              {originUser.displayName}
            </Typography>
            <Typography sx={{ fontSize: "13px" }}>
              {originUser.email}
            </Typography>
          </Box>
        )}
        {/* User Profile Link */}
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            padding: "30px 0 12px 25px",
            gap: "10px",
          }}
          onMouseEnter={() => setIsFolderHover(true)}
          onMouseLeave={() => setIsFolderHover(false)}
        >
          {isFolderHover ? <FolderHover /> : <Folder />}
          <Typography
            sx={{
              color: isFolderHover ? "#8695cb" : "#172664",
              fontSize: "15px",
            }}
          >
            <Link
              href="/account/profile"
              target="_blank"
              underline="none"
              sx={{
                color: isFolderHover ? "#8695cb" : "#172664",
              }}
            >
              Account Profile
            </Link>
          </Typography>
        </Box>

        {/* Divider */}
        <Divider variant="middle" flexItem sx={{ borderColor: "#d5d5d5" }} />

        {/* Log out Link */}
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            padding: "12px 25px",
            gap: "10px",
          }}
          onMouseEnter={() => setIsLogoutHover(true)}
          onMouseLeave={() => setIsLogoutHover(false)}
        >
          {isLogoutHover ? <LogoutHover /> : <Logout />}

          <Typography
            sx={{
              color: isLogoutHover ? "#8695cb" : "#172664",
              fontSize: "15px",
            }}
          >
            <Link
              component="button"
              type="button"
              onClick={async () => {
                try {
                  const response = await sendRequest(
                    "casdoor/UserService/.logoutUser",
                  );

                  if (response?.status === "ok") {
                    const token = localStorage.getItem("token");

                    if (!token || token === "null" || token === "undefined") {
                      console.error("No valid token");
                      return;
                    }

                    window.location.href =
                      `${serverURL}/api/logout?id_token_hint=${encodeURIComponent(token)}` +
                      `&post_logout_redirect_uri=${encodeURIComponent(`${serverApiURL}/login`)}`;
                  } else {
                    console.error("Logout API failed:", response);
                  }
                } catch (error) {
                  console.error("Logout error:", error);
                }
              }}
              underline="none"
              sx={{
                color: isLogoutHover ? "#8695cb" : "#172664",
              }}
            >
              Log out
            </Link>
          </Typography>
        </Box>
      </Menu>
    </Box>
  );
}
